import Layout from '@/components/Layout';

export default [
  {
    path: '/console',
    component: Layout,
    children: [
      {
        path: 'corporation',
        component: () => import('@/views/console/corporation'),
        name: 'corporationConsole',
        meta: {
          permissions: ['View:Corporation'],
          title: '企业信息',
        },
      },
      {
        path: 'contacts',
        component: () => import('@/views/console/contacts'),
        name: 'corporationConsoleContacts',
        meta: {
          permissions: ['Update:Corporation'],
          title: '企业联系人管理',
        },
      },
      {
        path: 'config',
        component: () => import('@/views/console/config'),
        name: 'corporationConsoleConfig',
        meta: {
          permissions: ['Update:Corporation'],
          title: '坐标系管理',
        },
      },
      // {
      //   path: 'ps',
      //   component: () => import('@/views/console/ps'),
      //   name: 'corporationConsolePs',
      //   meta: {
      //     permissions: ['View:Corporation'],
      //     title: '企业简介视频',
      //   },
      // },
      {
        path: 'users',
        component: () => import('@/views/console/user'),
        name: 'userConsole',
        meta: {
          permissions: ['View:User'],
          title: '账号管理',
        },
      },
      {
        path: 'roles',
        component: () => import('@/views/console/role'),
        name: 'roleConsole',
        meta: {
          permissions: ['View:Role'],
          title: '角色权限',
        },
      },
      {
        path: 'user-groups',
        component: () => import('@/views/console/userGroup'),
        name: 'userGroupConsole',
        meta: {
          permissions: ['View:UserGroup'],
          title: '账号分组',
        },
      },
      {
        path: 'projects',
        component: () => import('@/views/project'),
        name: 'projectConsole',
        meta: {
          permissions: ['View:Project'],
          title: '项目管理',
        },
      },
      {
        path: 'devices',
        component: () => import('@/views/device'),
        name: 'deviceConsole',
        meta: {
          permissions: ['View:Device'],
          title: '设备管理',
          attachProject: true,
        },
      },
      // {
      //   path: 'pushStrategy',
      //   component: () => import('@/views/console/pushStrategy'),
      //   name: 'pushStrategyConsole',
      //   meta: {
      //     permissions: ['Create:PushRule', 'Delete:PushRule', 'Update:PushRule'],
      //     title: '推送策略',
      //   },
      // },
      {
        path: 'operationLog',
        component: () => import('@/views/console/operationLog'),
        name: 'operationLog',
        meta: {
          permissions: ['View:OperationLog'],
          title: '操作记录',
        },
      },
      {
        path: 'shift',
        name: 'ConsoleShift',
        component: () => import('@/views/project/shift'),
        meta: {
          title: '移位校正',
        },
      },
      {
        path: 'shiftList',
        name: 'ConsoleShiftList',
        component: () => import('@/views/project/shift/list'),
        meta: {
          title: '移位校正记录',
        },
      },
    ],
  },
];
